import API from '..';
const ENTITY = 'political-divisions';

export const getItems = ({ country, political_division } = {}) =>
    API.get(`/api/v1/${ENTITY}/`, { params: { country, political_division } });
